import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import TextTruncate from 'react-text-truncate';
import { LayerStyleHelper } from '../util/StyleHelper';
import { formatTitle } from '../util/TitleHelper';
import ArcGISLegendColors from './ArcGISLegendColors';

// colorSection marker for ArcGIS feature services, whose recolorable legend
// renders from props on each render.
const ARCGIS_LEGEND = 'arcgis';
// import chroma from 'chroma-js';

// const isArrayOfObjects = (arr) => {
//   return (
//     Array.isArray(arr) &&
//     arr.every(
//       (item) =>
//         typeof item === 'object' && item !== null && !Array.isArray(item)
//     )
//   );
// };

const ForestDataMapLegend = (props) => {
  const { item, itemGis, colorOverrides, setColorOverrides } = props;
  const [display, setDisplay] = useState(false);
  const [colorSection, setColorSection] = useState(null);
  const [view, setView] = useState(false);
  const [units, setUnits] = useState(null);

  const handleRotate = () => setDisplay(!display);

  const handleBuildLegendUrl = (layerName) => {
    const sld = LayerStyleHelper(layerName);
    if (sld) {
      let style = null;
      let otherLayerName = null;
      if (sld.includes('_std')) {
        style = sld;
      } else {
        otherLayerName = sld;
      }
      const params = new URLSearchParams({
        service: 'WMS',
        version: '1.1.0',
        request: 'GetLegendGraphic',
        layer: otherLayerName ? otherLayerName : layerName,
        format: 'image/png',
        width: '20',
        height: '20',
        legend_options:
          'fontAntiAliasing:true;fontSize:10;fontName:Arial;dx:5;absoluteMargins:true',
      });

      if (style) {
        params.append('style', style);
      }
      return `${itemGis.service_url}?${params.toString()}`;
    }
  };
  useEffect(() => {
    item.extras.forEach((obj) => {
      if (obj.key === 'data_units') {
        setUnits(obj.value);
      }
    });

    if (itemGis.service_type === 'ArcGISTile') {
      // Cached MapServers still serve their own legend (swatch images plus
      // labels, e.g. a stretched ramp's value range).
      let cancelled = false;
      fetch(`${itemGis.service_url}/legend?f=json`)
        .then((response) => response.json())
        .then((json) => {
          const entries = (json.layers || []).flatMap((l) => l.legend || []);
          if (cancelled || entries.length === 0) return;
          setColorSection(
            <div>
              {entries.map((entry, i) => (
                <div
                  key={i}
                  style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                >
                  <img
                    src={`data:${entry.contentType};base64,${entry.imageData}`}
                    alt=""
                    width={entry.width}
                    height={entry.height}
                  />
                  <span>{formatTitle(entry.label)}</span>
                </div>
              ))}
            </div>
          );
        })
        .catch((error) => console.error('Failed to load tile legend:', error));
      return () => {
        cancelled = true;
      };
    }

    if (itemGis.service_type === 'ArcGIS') {
      // Rendered live from the recolors below rather than stored here.
      setColorSection(ARCGIS_LEGEND);
      return;
    }

    const legendUrl = handleBuildLegendUrl(itemGis.layer_name);
    setColorSection(
      <div>
        <img
          src={legendUrl}
          alt={`Legend for ${formatTitle(item.title)}`}
          className="legend-image"
        />
      </div>
    );
  }, []);

  return (
    <>
      {colorSection && (
        <span>
          {/* "Legend" sits inside the button so it has an accessible name. */}
          <Button
            style={{
              textDecoration: 'none',
              color: '#2C3E37',
              paddingLeft: 0,
            }}
            onClick={handleRotate}
            variant="link"
            size="sm"
            aria-expanded={display}
          >
            {display ? (
              <FaChevronUp aria-hidden="true" />
            ) : (
              <FaChevronDown aria-hidden="true" />
            )}{' '}
            Legend
          </Button>
          {display && colorSection === ARCGIS_LEGEND ? (
            <ArcGISLegendColors
              colorMap={itemGis.color_map}
              overrides={colorOverrides}
              onChange={setColorOverrides}
            />
          ) : display ? (
            colorSection
          ) : null}
          {display && units && (
            <div>
              Units:{' '}
              {view || units.length <= 100 ? (
                <span>{units}</span>
              ) : (
                <>
                  <TextTruncate
                    line={2}
                    element="span"
                    truncateText="…"
                    text={units}
                  />
                </>
              )}
              <br />
              {units.length >= 100 && (
                <Button
                  size="sm"
                  variant="link"
                  onClick={() => {
                    setView(!view);
                  }}
                  style={{ padding: 0, color: 'green' }}
                >
                  {view ? 'Show Less' : 'Show More'}
                </Button>
              )}
            </div>
          )}
        </span>
      )}
    </>
  );
};
export default ForestDataMapLegend;
